import { FormGeneratedEntity } from "./generated/FormGeneratedEntity";

export abstract class FormEntity extends FormGeneratedEntity {
    // Comment to preserve new line
}
